import React from "react";
import styled from "styled-components";
import { Row, Col } from "antd";
import Mainnav from "../../../Common/Components/Mainnav";
import EditItemName from "../../../Common/Components/EditItemName";
import BlogItem from "../../../Common/Components/BlogItem";
import BlogItemTwo from "../../../Common/Components/BlogItemTwo";
import BlogItemThree from "../../../Common/Components/BlogItemThree";
import ToggleView from "../../../Common/Components/ToggleView";
import Checkbox from "../../../Common/Components/Checkbox";
import TabOptions from "../../../Common/Components/TabOptions";
import SelectWithIcon from "../../Shared/SelectWithIcon";
import SavedSearch from "../../../Content/Search/Components/SavedSearch";
import SearchTerm from "../../../Content/Search/Components/SearchTerm";
import SearchTermExtended from "../../../Content/Search/Components/SearchTermExtended";
import { ReactComponent as Sort } from "../../../../assets/img/icons/Sort.svg";
import { ReactComponent as Calender } from "../../../../assets/img/icons/Campaign/Calender.svg";
import CampaignsTab from "./CampaignsTab";

const DigestWithSearchTabs = [
  {
    pillName: "Dashboard",
    to: "/#",
    isActive: true,
  },
  {
    pillName: "Audience",
    to: "/#",
    isActive: false,
  },
];

interface IDigestWithSearch {
  page?: string;
  tab?: string;
}

const DigestWithSearch: React.FC<IDigestWithSearch> = (props) => {
  const [enableActiveSearch, setEnableActiveSearch] = React.useState(false);
  const { tab, page } = props;
  const toggleActiveSearch = (e: any) => {
    setEnableActiveSearch(!enableActiveSearch);
  };
  React.useEffect(() => {
    document.addEventListener("mousedown", (event) => {
      const concernedElement: any = document.querySelector(".collapsable-search");
      const concernedElement1: any = document.querySelector(".results-list-term");

      if (concernedElement) {
        if (!concernedElement.contains(event.target) && !concernedElement1.contains(event.target)) {
          setEnableActiveSearch(false);
        }
      }
    });
  }, []);
  return (
    <Wrapper>
      <div className="wrapper-box">
        <EditItemName itemName="Digest name goes here" itemTitle="Digest" />
        <div className="margin-top-md margin-bottom-md">
          <CampaignsTab page={page} tab={tab} />
        </div>
        <Row className="">
          <Col span={24}>
            <ul className="tabs-wrapper">
              <li className="search-wrapper">
                <SearchTerm searchTerm="Microsoft" />
                <SearchTerm searchTerm="Microsoft" />
                <SearchTerm searchTerm="Microsoft" />
                <SearchTerm searchTerm="Microsoft" />
                <SearchTermExtended count="+45" onClick={toggleActiveSearch} />
                <div className={`results-list-term ${enableActiveSearch && "active-search"}`}>
                  {/* Toggle active-search Class */}
                  <div className="search-fist-row">
                    <SearchTerm searchTerm="Microsoft" />
                    <SearchTerm searchTerm="Microsoft" />
                    <SearchTerm searchTerm="Microsoft" />
                    <SearchTerm searchTerm="Microsoft" />
                  </div>
                  <div className="inner-wrapper">
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17].map((item) => (
                      <SearchTerm key={item} searchTerm="Microsoft" />
                    ))}
                    <input type="text" name="search" className="search-input" placeholder="" />
                  </div>
                </div>
              </li>
              <li className="right">
                <SavedSearch label="Update keywords…" />
              </li>
            </ul>
          </Col>
        </Row>
        <Row className="margin-top-lg margin-bottom-lg">
          <Col span={24}>
            <ul className="tabs-wrapper">
              <li>
                <ToggleView />
              </li>
              <li>
                <label>
                  <Checkbox /> Show My CMS content
                </label>
              </li>
              <li>
                <label>
                  <Checkbox /> Show Theme content
                </label>
              </li>
              <li className="right">
                <div className="results">4561 results</div>
              </li>
              <li className="right">
                <SelectWithIcon
                  emoji={<Sort style={{ height: 18, width: 18 }} />}
                  defaultValue={{ value: "Relevance", label: "Relevance" }}
                  options={[
                    { value: "Relevance", label: "Relevance" },
                    { value: "Type 1", label: "Type 1" },
                    { value: "Type 2", label: "Type 2" },
                    { value: "Type 3", label: "Type 3" },
                  ]}
                />
              </li>
              <li className="right">
                <SelectWithIcon
                  emoji={<Calender style={{ height: 18, width: 18 }} />}
                  defaultValue={{ value: "7 Days", label: "7 Days" }}
                  options={[
                    { value: "7 Days", label: "7 Days" },
                    { value: "Type 1", label: "Type 1" },
                    { value: "Type 2", label: "Type 2" },
                    { value: "Type 3", label: "Type 3" },
                  ]}
                />
              </li>
            </ul>
          </Col>
        </Row>
        <Row className="margin-top-md margin-bottom-md" gutter={24}>
          <Col span={12}>
            <BlogItem />
          </Col>
          <Col span={12}>
            <BlogItem />
          </Col>
        </Row>
        <Row className="margin-top-md margin-bottom-md" gutter={24}>
          <Col span={8}>
            <BlogItem />
          </Col>
          <Col span={8}>
            <BlogItem />
          </Col>
          <Col span={8}>
            <BlogItem />
          </Col>
        </Row>
        <Row className="margin-top-md margin-bottom-md" gutter={24}>
          <Col span={12}>
            <BlogItem />
          </Col>
          <Col span={12}>
            <div className="padding-bottom-md">
              <BlogItemTwo />
            </div>
            <div className="padding-bottom-md">
              <BlogItemTwo />
            </div>
            <BlogItemTwo />
          </Col>
        </Row>
        <Row className="margin-top-md margin-bottom-md" gutter={24}>
          <Col span={12}>
            <div className="padding-bottom-md">
              <BlogItemTwo />
            </div>
            <div className="padding-bottom-md">
              <BlogItemTwo />
            </div>
            <BlogItemTwo />
          </Col>
          <Col span={12}>
            <BlogItem />
          </Col>
        </Row>
        <Row className="margin-top-md margin-bottom-md" gutter={24}>
          <Col span={24}>
            <BlogItemThree />
            <BlogItemThree />
            <BlogItemThree />
            <BlogItemThree />
            <BlogItemThree />
            <BlogItemThree />
            <BlogItemThree />
          </Col>
        </Row>
      </div>
    </Wrapper>
  );
};

export default DigestWithSearch;

const Wrapper = styled.div`
  .wrapper-box {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    // padding: 70px 90px 0 90px;
    // @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    //   padding: 35px 50px 0 50px;
    // }
    ul.tabs-wrapper {
      list-style-type: none;
      padding: 0;
      margin: 0;
      display: block;
      li {
        margin: 5px 0px;
        float: left;
        display: inline;
        &:first-child {
          & > div {
            margin-left: 0;
          }
        }
        &.search-wrapper {
          padding-top: 5px;
          width: calc(100% - 210px);
          position: relative;
          .item-label {
            padding-right: 10px;
          }
          .clear-item {
            display: none;
          }
          .item-label {
            padding-right: 2px;
          }
          .results-list-term {
            background: #fff;
            padding: 5px 20px 5px 20px;
            margin: 0;
            border: 1px solid #dadada;
            border-radius: 20px;
            list-style: none;
            float: left;
            display: block;
            width: 100%;
            transition: 0.5s;
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
            z-index: -9;
            visibility: hidden;
            &.active-search {
              opacity: 1;
              visibility: visible;
              z-index: 9;
            }
            .search-fist-row {
              width: 100%;
              float: left;
              display: block;
            }
            .clear-item {
              display: inline;
            }
            &.empity {
              padding: 20px 20px 0 55px;
            }
            .inner-wrapper {
              width: 100%;
              float: left;
              display: block;
              margin: 10px 0 0px 0;
              .search-input {
                border: none;
                color: #424b50;
                font-weight: 400;
                font-size: 14px;
                font-family: "robotoregular";
                padding: 10px 5px;
                &:hover,
                &:active,
                &:focus {
                  border: none;
                  outline: none;
                }
              }
              > div {
                margin-bottom: 4px;
              }
              max-height: 280px;
              overflow-y: auto;
              scrollbar-width: thin;
              scrollbar-color: #001760 #efefef;
              ::-webkit-scrollbar {
                width: 5px;
                height: 5px;
                border-radius: 2px;
              }
              /* Track */
              ::-webkit-scrollbar-track {
                background: #efefef;
                margin-top: 10px;
                margin-bottom: 15px;
              }
              /* Handle */
              ::-webkit-scrollbar-thumb {
                background: #001760;
              }
              /* Handle on hover */
              ::-webkit-scrollbar-thumb:hover {
                background: #555;
              }
            }
            li {
              color: #5e7079;
              font-size: 16px;
              line-height: 34px;
              padding: 0;
              list-style: none;
              width: 100%;
              display: flex;
              justify-content: space-between;
              cursor: pointer;
              transition: 0.5s;
              span {
                color: #c5c5c5;
                font-size: 12px;
                font-family: "robotoregular", sans-serif;
              }
            }
          }
        }
        &.right {
          float: right;
        }
        label {
          color: #7e7e7e;
          font-size: 16px;
          font-weight: 500;
          font-family: "robotomedium";
          margin: 5px 20px;
        }
        .results {
          color: #7e7e7e;
          font-weight: 500;
          font-family: "robotomedium";
          margin: 8px 0 0 15px;
        }
        & > div {
          margin: 0 5px;
        }
      }
    }
  }
`;
